module.exports = __webpack_public_path__ + "static/media/3.cec193a4.png";